import TaxiBanner from "./TaxiBanner";
import { lazy, memo, Suspense } from "react";

const BookingApp = lazy(() => import("./BookingApp"));
const BookingManagement = lazy(() => import("./BookingManagement"));
const TaxiService = lazy(() => import("./TaxiService"));
const Infotech = lazy(() => import("./Infotech"));
const TaxiLabel = lazy(() => import("./TaxiLabel"));
const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const ShuttleItNeed = lazy(() => import("../shuttle_software/ShuttleItNeed"));
const TaxiFaq = lazy(() => import("./TaxiFaq"));
const OnDemandWork = lazy(() => import('../cloneApps/onDemand/OnDemandWork'));

const faqData = [
  {
    id: "0",
    question: "01. Is there any additional cost for integrations?",
    answer:
      "No, our airport transfer software integrates seamlessly with your existing systems, including flight tracking and payment gateways, without any extra charges for integrations.",
  },
  {
    id: "1",
    question: "02. Can I have my own branding?",
    answer:
      "Yes, our solution is fully customizable to reflect your brand’s identity, including logos, colors, and branding elements.",
  },
  {
    id: "2",
    question: "03. Is there any set-up cost?",
    answer:
      "We offer flexible pricing options. Any initial setup fees will be clearly discussed during your consultation, based on your business needs.",
  },
  {
    id: "3",
    question: "04. Do you have an invoicing module?",
    answer:
      "Yes, our software includes a comprehensive invoicing module that allows automatic generation of invoices, fare breakdowns, and detailed billing for easy record-keeping.",
  },
  {
    id: "4",
    question: "05. Can the customers communicate with the drivers in real-time?",
    answer:
      "Yes, customers can communicate with drivers through in-app messaging or calls, ensuring a smooth ride experience and resolving any potential issues promptly.",
  },
  {
    id: "5",
    question: "06. Can I approve/reject the driver/agent if they register themselves from the mobile application?",
    answer:
      "Yes, our admin dashboard gives you full control to approve or reject drivers/agents after reviewing their credentials before they go live on the platform.",
  },
  {
    id: "6",
    question:
      "07. Does the system support flight delays and real-time flight status updates?",
    answer:
      "Yes. Our airport transfer software is fully integrated with flight-tracking systems. It automatically detects delays, early arrivals, gate changes, and cancellations, updating both passengers and drivers instantly.",
  },
  {
    id: "7",
    question: "08. Can the software handle multiple vehicle types (sedan, SUV, shuttle, private chauffeurs)?",
    answer:
      "Absolutely. The system is built to support any fleet configuration, whether you operate standard sedans, luxury SUVs, group shuttle vans, minibuses, or premium chauffeur vehicles.",
  },
];

const airportFeatureId = "airport-transfer-software";

export default memo(function TaxiDispatchSoftware() {
  return (
    <>
      <TaxiBanner featureId={airportFeatureId} />

      <Suspense fallback={null}>
        <BookingApp />
        <BookingManagement />
        <TaxiService />
        <Infotech />
        <TaxiLabel />
        <div className="solution-case">
          <OnDemandWork />
        </div>
        <ShuttleAppreciation />
        <ShuttleItNeed featureId={airportFeatureId} />
        <TaxiFaq faqData={faqData} />
      </Suspense>
    </>
  );
});